import { Link, Text, View } from "@react-pdf/renderer";

import { QRCode } from "../assets/QRCode";
import { styles } from "../styles";

export const PdfFooter = () => (
  <View style={styles.footer} fixed>
    <View
      style={{
        flexDirection: "row",
        columnGap: 10,
        alignItems: "center",
      }}
    >
      <Link src="https://psychnow.com/chapter">
        <QRCode width={38} />
      </Link>
      <Text>Bringing patient stories to light</Text>
    </View>
    <Text
      style={{ fontSize: 8 }}
      render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
    />
  </View>
);
